<template>
  <td :tabindex="props.tabIndex" @keypress.enter="props.toggle" @click="props.toggle">
        <span :class="`VueTables__child-row-toggler ${props.class()}`">
            <button class="btn btn-primary btn-sm">
                <i class="feather icon-info mr-25"></i>
              {{lexicon.drop_btn_info}}
            </button>
        </span>
  </td>
</template>

<script>
import {mapState} from 'vuex'

export default {
  name: "MyChildRowToggler",
  props: ['props'],
  computed: mapState({
    lexicon: state => state.lexicon
  }),
}
</script>